import React from 'react'

import ContactForm from '../components/ContactForm'

import { GatsbyJumbotron } from '../components/MyStyledComponents'

import {
  Button,
  Container,
  Divider,
  Header,
  Icon,
  Segment,
  Accordion,
} from 'semantic-ui-react'
import Layout from '../components/layout'

import Img from 'gatsby-image'

import { useStaticQuery, graphql } from 'gatsby'

export default function Contact() {
  const data = useStaticQuery(graphql`
    query {
      allMarkdownRemark(
        filter: { fileAbsolutePath: { regex: "/(contactPanels)/" } }
      ) {
        nodes {
          id
          html
          frontmatter {
            title
          }
        }
      }
      startingTheJourney: allMarkdownRemark(
        filter: { fileAbsolutePath: { regex: "/(startingTheJourney)/" } }
      ) {
        nodes {
          id
          html
          frontmatter {
            title
          }
        }
      }
      location: allMarkdownRemark(
        filter: { fileAbsolutePath: { regex: "/(location)/" } }
      ) {
        nodes {
          id
          html
          frontmatter {
            title
          }
        }
      }
      trees: file(relativePath: { regex: "/(images/resources/contact)/" }) {
        childImageSharp {
          fluid(fit: CONTAIN) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)

  const startingTheJourney = (
    <div
      dangerouslySetInnerHTML={{
        __html: data.startingTheJourney.nodes[0].html,
      }}
    />
  )
  const location = (
    <div
      dangerouslySetInnerHTML={{
        __html: data.location.nodes[0].html,
      }}
    />
  )

  const panels = data.allMarkdownRemark.nodes.map(p => {
    return {
      key: p.frontmatter.title,
      title: p.frontmatter.title,
      content: {
        content: <Container dangerouslySetInnerHTML={{ __html: p.html }} />,
      },
    }
  })

  return (
    <Layout>
      {/* <Jumbotron imgDir="images/image_16/" src={pathImg} /> */}
      <GatsbyJumbotron>
        <Img alt="path of trees" fluid={data.trees.childImageSharp.fluid} />
      </GatsbyJumbotron>
      <Divider hidden />
      <Container text>
        {startingTheJourney}

        <Divider hidden />

        <ContactForm />

        <Divider />

        {location}

        <Divider hidden />

        <Segment textAlign="center" padded="very" size="large">
          <Header as="h2" icon>
            <Icon name="map marker alternate" color="teal" />
            Practice Address
          </Header>
          <p style={{ fontSize: '1.25em', lineHeight: '1.6', margin: 0 }}>
            20-24 John Street
            <br />
            Camden NSW 2570
          </p>
          <p style={{ color: '#888', marginTop: '0.75em' }}>
            <em>Cross street: Mitchell Street</em>
          </p>
          <Button
            as="a"
            href="https://www.google.com/maps/dir/?api=1&destination=20-24+John+Street,+Camden+NSW"
            target="_blank"
            rel="noopener noreferrer"
            color="teal"
            icon
            labelPosition="left"
          >
            <Icon name="map" />
            Get Directions
          </Button>
        </Segment>
        <Divider hidden />

        <Divider />

        <Header as="h1" content="Additional Information" />
        <Accordion defaultActiveIndex={0} fluid styled panels={panels} />
      </Container>
    </Layout>
  )
}
